import React, { useState } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './ShareButton.scss';
import SocialWidget from '../../../../articleshow_v2/components/common/SocialWidget/SocialWidget';

const ShareButton = props => {
  const [showSocialWidget, setShowSocialWidget] = useState(false);
  const {
    title,
    url,
    nativeIconClassName,
    gaCat,
    gaOnClick,
    popupWrapperClass,
  } = props;

  const showSocialShareWidget = () => {
    setShowSocialWidget(true);
  };

  const hideSocialShareWidget = () => {
    setShowSocialWidget(false);
  };
  return (
    <div className={s.socialShare}>
      <div
        className={`${s.timelineshare} icon_share_wrap ${nativeIconClassName}`}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof gaOnClick === 'function') {
            gaOnClick();
          } else {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: 'social_share',
              category: gaCat,
            });
          }
        }}
        onMouseEnter={showSocialShareWidget}
        onMouseLeave={hideSocialShareWidget}
      >
        <div className={`${s.icon_share} ${nativeIconClassName}`}>
          <i className={`${s.shareicon} ${showSocialWidget ? s.active : ''}`} />
          <span>
            {' '}
            {nativeIconClassName === '' || nativeIconClassName === undefined
              ? 'Share'
              : ''}
          </span>
        </div>
        {showSocialWidget && (
          <SocialWidget
            // msid={cartoonData.id}
            isParent
            url={`${url}?`}
            title={title}
            className={s.icon_hover_social}
            isWapView={false}
            isSmallicon
            // openSidebar={this.openSidebar}
            //isLiveBlog
            // commentsCount={this.props.commentsCount}
            // wu={`${TOI_LIVE_DOMAIN}${getLinkURL(
            //   cartoonData?.id,
            //   cartoonData?.seolocation,
            // )}`}
            //via={this.props.via}
            type="ATF"
            gaCategory="ToiGames_cat"
            gaAction="click"
            gaIndex="atfShare_"
            textRequired={false}
            linkeDin
            via="@timesofindia"
            wrapperClass={popupWrapperClass}
          />
        )}
      </div>
    </div>
  );
};
export default ShareButton;
